interface BrandLogoProps {
  variant?: "wordmark" | "mark";
  label?: string;
  className?: string;
}

export function BrandLogo({
  variant = "wordmark",
  label,
  className = "",
}: BrandLogoProps) {
  const classes = ["brand-logo", `brand-logo--${variant}`, className]
    .filter(Boolean)
    .join(" ");

  if (label) {
    return <span className={classes} role="img" aria-label={label} />;
  }

  return <span className={classes} aria-hidden />;
}
